import Vue from 'vue'
import UserAuth from '@/components/UserAuth/UserAuth.vue'
import {ready} from '@/shared'

ready(function () {
  new Vue({ // eslint-disable-line no-new
    el: '#js-user-auth',

    components: {
      UserAuth
    },

    render: h => h('UserAuth')
  })
})



// WEBPACK FOOTER //
// ./src/user.js